import React, { FC } from 'react';
import { Panel } from '@component/Panel';
import { ASSETS_PATH } from '@app/react/const/variables';
import {
    OrderPartsHelpContents,
    Title,
    SubTitle,
    Paragraph,
    Image,
} from './OrderPartsHelpContents';
import { SakuraIcon } from './SakuraIcon';
import { OrderPartsHelpProps } from './type';
import { handleKeyPress } from './handleKeyPress';

const IMG_PATH = `${ASSETS_PATH}/img/order-help/thread`;

interface Props {
    className?: string;
}

export const ThreadInner: FC<Props> = ({ className }) => (
    <OrderPartsHelpContents className={className}>
        <Title>
            <SakuraIcon />
            糸・和紙の選び方
        </Title>
        <Image src={`${IMG_PATH}/thread.png`} />

        <Paragraph>
            ※表示している糸・和紙の色は、製品となったときに多少明るく見えたり、
            ご覧いただいている画面の環境によって色の見え方が多少異なりますので、ご了承ください。
        </Paragraph>

        <SubTitle>選び方</SubTitle>
        <Paragraph>
            矧糸部に和紙を使用して仕上げたものです。
            単色でないため、１本１本違った仕上がり模様となります。
            長い伝統を持つ和紙による矧巻き仕上げは、とても矢と相性が良く、
            古来より続く伝統技法になっております。お楽しみ下さい。
        </Paragraph>
    </OrderPartsHelpContents>
);

export const OrderPartsHelpThread: FC<OrderPartsHelpProps> = ({
    isOpen,
    handleClose,
}) => (
    <Panel isOpen={isOpen} onRequestClose={handleClose}>
        <div
            className="order-parts-help-panel-close"
            onClick={handleClose}
            onKeyPress={handleKeyPress(handleClose)}
            role="button"
            tabIndex="0"
        >
            <i className="icon-close" />
        </div>
        <div className="order-parts-help-panel">
            <div className="scrollable">
                <ThreadInner />
            </div>
        </div>
    </Panel>
);
